import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { useModal } from "../../common/hooks/useModal";
import CourseService from "../../services/CourseService";

export default function FormCourse() {
  const { t } = useTranslation();
  const { dataModal, onCloseModalReset, handleStopSaveModal } = useModal();

  const [name, setName] = useState("");

  const loadCourse = async (id: any) => {
    if (!id) return;
    await CourseService.get(id)
      .then((response: any) => {
        if (response) {
          setName(response.data.name);
        }
      })
      .catch(() => {});
  };

  const handleSubmit = () => {
    if (name == "") {
      toast(t("toast_form_competence_description") || "Por favor, digite o nome", {
        type: "error",
      });
      handleStopSaveModal();
      return;
    }

    const data = { name };

    if (!dataModal?.data?.idCourse) {
      CourseService.store(data)
        .then((response: any) => {
          if (response?.data?.Msg) {
            // reload list if callback provided
            if (dataModal?.data?.loadCourses) dataModal.data.loadCourses(1, 0);
            // call parent's onCreated if provided
            try {

              let newId: any = response?.data?.id;
              if (!newId && response?.data) {
                const anyData: any = response.data;
                if (anyData?.course?.id) newId = anyData.course.id;
              }
              if (newId && dataModal?.data?.onCreated) dataModal.data.onCreated(newId);
            } catch (err) {}
            toast(response?.data?.Msg, { type: "success" });
            onCloseModalReset();
          }
        })
        .catch((e: any) => {
          handleStopSaveModal();
          toast(e?.response?.data?.Error, { type: "error" });
        });
    } else {
      CourseService.update(dataModal?.data?.idCourse, data)
        .then((response: any) => {
          if (response?.data?.Msg) {
            if (dataModal?.data?.loadCourses) dataModal.data.loadCourses(1, 0);
            toast(response?.data?.Msg, { type: "success" });
            onCloseModalReset();
          }
        })
        .catch((e: any) => {
          toast(e?.response?.data?.Error, { type: "error" });
        });
    }
  };

  useEffect(() => {
    if (dataModal?.data?.idCourse) {
      loadCourse(dataModal.data.idCourse);
    }
    if (dataModal.loadingBtnSave) {
      handleSubmit();
    }
  }, [dataModal.loadingBtnSave]);

  return (
    <Box>
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          required
          fullWidth
          id="name"
          name="name"
          label={t("input_label_course") || "Nome do curso"}
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Box>
    </Box>
  );
}
